/**
 * Barrel export for {@link LineItemInlineEditRowContainer}.
 * @module features/contracts/components/LineItemInlineEditRow
 */

export { default } from "./LineItemInlineEditRowContainer";
